module.exports = __webpack_public_path__ + "static/media/valor4_1.713a0dfb.mp4";